import { BarLoader } from "react-spinners";
import Favicon from "../../assets/favicon-32x32.png";

const CommonLoading = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-8">
      <img 
        src={Favicon} 
        alt="SkillConnect" 
        className="w-10 h-8"
      />
      <BarLoader color="var(--primary-color)" height={5} width={100} />
    </div>
  );
};

export default CommonLoading;
